var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndex2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222.65 121.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:#f5e3cb;}.cls-3{fill:#e1c8aa;}.cls-4{fill:#c6a07d;}.cls-5{fill:#a27753;}.cls-6{fill:#645246;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 111.35,
    cy: 111.05,
    r: 10.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.77,111.05a2.44,2.44,0,0,0,0,.27H0A110.83,110.83,0,0,1,21.17,46l67.6,49.12A27.72,27.72,0,0,0,83.77,111.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.44,84.76A27.93,27.93,0,0,0,88.77,95.12L21.17,46A111.62,111.62,0,0,1,76.69,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.51,5.35l-25.7,79.09a27.92,27.92,0,0,0-17.37.32L76.69,5.49a111.94,111.94,0,0,1,68.82-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M201.3,45.77,134.06,94.62a27.86,27.86,0,0,0-14.25-10.18l25.7-79.09A111.47,111.47,0,0,1,201.3,45.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M139.43,111.32v-.27a27.67,27.67,0,0,0-5.37-16.43L201.3,45.77a110.83,110.83,0,0,1,21.35,65.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 111.63,
    y1: 111.37,
    x2: 62.3,
    y2: 44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.97 114.78 62.05 44.18 62.55 43.81 116.29 107.96 106.97 114.78 106.97 114.78"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex2);
export default __webpack_public_path__ + "static/media/index2.2bdab8fb6779a04d9678e994f7d60cc1.svg";
export { ForwardRef as ReactComponent };